import { Action } from "~/modules/actions/Action";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger, LoggerName } from "~/modules/logger";
import { CbmImpl } from "~/modules/cbm";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { getReservationsByTask, sendTrackingEvent } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";



















export class PauseConversationChannel implements Action<Promise<void>> {
    


    #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    
    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const logger = getLogger(context)(LoggerName.Actions);

        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const worker = taskRouter.worker;

        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();
        logger.debug(`pauseConversationChannel invoked with taskSid: ${this.#taskSid}`);

        const task = getReservationsByTask(worker, this.#taskSid)[0]?.task;

        if (!task) {
            const errorMsg = `pauseConversationChannel: Task not found for taskSid ${this.#taskSid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.PauseConversationChannelCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const interactionSid = task.attributes.flexInteractionSid;
        const channelSid = task.attributes.flexInteractionChannelSid;

        if (!interactionSid) {
            const errorMsg = `pauseConversationChannel: Missing interactionSid for taskSid ${this.#taskSid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.PauseConversationChannelCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        if (!channelSid) {
            const errorMsg = `pauseConversationChannel: Missing channelSid for taskSid ${this.#taskSid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.PauseConversationChannelCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                interactionSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        try {
            await cbm.pauseChannel(interactionSid, channelSid, "pause", "closed");

            sendTrackingEvent(EVENTS.PauseConversationChannelCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                interactionSid,
                channelSid
            });

            return Promise.resolve();
        } catch (e) {
            const errorMsg = `pauseConversationChannel: Failed to pause conversation channel for taskSid ${
                this.#taskSid
            }`;
            logger.error(errorMsg);

            sendTrackingEvent(EVENTS.PauseConversationChannelCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                interactionSid,
                channelSid
            });

            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
